<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :data="data"/>
      </div>
      <div class="column">
        <Client :data="data"/>
      </div>
    </div>

    <InvoiceList class="block" :invoiceList="data.InvoiceList"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../RcpyModel.js";
import Services from "../../../services/Api/RecPayServices.js";

import Details from "./RcpyPD_Details.vue";
import Client from "./RcpyPD_Client.vue";
import InvoiceList from "./RcpyPD_InvoiceList.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Client,
    InvoiceList,
    Company
  },
  data: () => ({
    data: {},
    companyData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
      this.companyData = data.CompanyDetails;

      Model.setDetailsByStatus(this.data);
    },

    /*** custom ***/

    resetData() {
      this.data = {};
      this.companyData = {};
    }
  }
}
</script>